<template>
  <div class="container article">
    <div class="contentTop">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>学长</el-breadcrumb-item>
        <el-breadcrumb-item>沟通管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div style="display:flex;">
        <div class="service"
             style="marginRight:10px"
             @click="service()">客服设置</div>
        <div class="create"
             style="marginRight:10px"
             @click="create()">自动回复设置</div>
        <div class="create"
             @click="sensitive()">敏感词设置</div>
      </div>
    </div>
    <div class="filters card">
      <div class="content">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="学员信息"
                        prop="name"
                        v-if="check_statuses=='0'||check_statuses=='2'">
            <el-input v-model="query.point_a_user_keyword"
                      placeholder="请输入学员姓名/手机号"
                      @input="fetchList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="沟通对象"
                        prop="name"
                        v-if="check_statuses=='0'||check_statuses=='2'">
            <el-input v-model="query.point_b_user_keyword"
                      placeholder="请输入对象姓名/手机号"
                      @input="fetchList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="消息内容"
                        prop="name"
                        v-if="check_statuses=='1'">
            <el-input v-model="mquery.message_keyword "
                      placeholder="输入消息内容"
                      @input="messageList()"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="消息状态"
                        v-if="check_statuses=='1'">
            <el-select v-model="mquery.message_statuses"
                       @change="messageList()"
                       clearable
                       placeholder="请选择类型"
                       style="width: 100%;">
              <el-option v-for="(item, index) in filter.status"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息条数"
                        v-if="check_statuses=='0'||check_statuses=='2'">
            <el-select v-model="query.min_message_count "
                       @change="fetchList(true)"
                       placeholder="请选择类型"
                       style="width: 100%;">
              <el-option v-for="(item, index) in filter.count"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="答疑状态"
                        v-if="check_statuses=='0'||check_statuses=='2'">
            <el-select v-model="query.chat_lock_status"
                       @change="fetchList()"
                       clearable
                       placeholder="请选择答疑状态"
                       style="width: 100%;">
              <el-option v-for="(item, index) in filter.chat_lock_status"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="答疑状态"
                        v-if="check_statuses=='1'">
            <el-select v-model="mquery.chat_lock_status"
                       @change="messageList()"
                       clearable
                       placeholder="请选择答疑状态"
                       style="width: 100%;">
              <el-option v-for="(item, index) in filter.chat_lock_status"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="results card">
      <div class="table-header">
        <div class="tableleft">
          <div class="blue"
               style="marginRight:5px"></div>
          <h3 class="title">列表</h3>
        </div>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="check_statuses"
                            @change="checkStatus">
              <el-radio-button v-for="(item, index) in filter.type"
                               :key="index"
                               :label="item.value">

                <el-badge :value="unRead"
                          :hidden="item.value =='0'||item.value =='1'"
                          class="radio-badge">
                  {{ item.label }}
                </el-badge>
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="dataList"
                border
                style="width: 100%"
                v-if="check_statuses=='0'||check_statuses=='2'">
        <el-table-column prop="chat_no"
                         width="200"
                         label="编号"
                         align="center">
        </el-table-column>
        <el-table-column label="学员"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link v-if="scope.row.point_a_user_obj"
                     type="primary"
                     @click="handleLookUser(scope.row.point_a_user_obj.id,false)">{{ scope.row.point_a_user_obj.nickname}}</el-link>
            <span v-else>/</span></template>
        </el-table-column>
        <el-table-column label="沟通对象"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link type="primary"
                     v-if="scope.row.point_b_user_obj"
                     @click="handleLookUser(scope.row.point_b_user_obj.id,true)">{{ scope.row.point_b_user_obj.nickname}}</el-link></template>
        </el-table-column>
        <el-table-column label="沟通条数"
                         width="200"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.message_count}}条</span> <span class="unread"
                  v-if="scope.row.sys_looked_status==0">未读</span></template>
        </el-table-column>
        <el-table-column label="答疑截止时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link type="primary"
                     @click="handleAnswer(scope.row)">
              {{
                scope.row.answer_unlock_expire_time
                  ? $moment(scope.row.answer_unlock_expire_time).format("YYYY-MM-DD HH:mm")
                  : "-"
              }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="最新消息时间"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.last_message_create_time
                  ? $moment(scope.row.last_message_create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="创建沟通时间"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="200"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handelDetail(scope.row,1)"><span goDetailclass="cao">查看详情</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="undercarriage(scope.row,1)"><span class="cao">打招呼</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="dialogDelete(scope.row)"><span class="cao">删除</span></el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="result"
                border
                style="width: 100%"
                v-if="check_statuses=='1'">
        <el-table-column label="发送时间"
                         align="center"
                         width="200"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{
                scope.row.create_time
                  ? $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm:ss")
                  : ""
              }}
          </template>
        </el-table-column>
        <el-table-column prop="message"
                         width="600"
                         label="消息内容"
                         align="left">
          <template slot-scope="scope">

            <el-image v-if="scope.row.content_type==2&&scope.row.message_img_url"
                      :src="scope.row.message_img_url"
                      class="thumbnail"
                      :preview-src-list="[scope.row.message_img_url]"> </el-image>
            <span v-else-if="scope.row.content_type==5">[推荐报名1v1]</span>
            <span v-else>{{scope.row.message}}</span>

          </template>

        </el-table-column>
        <el-table-column prop="chat_no"
                         width="160"
                         label="沟通编号"
                         align="center">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handelDetail(scope.row,2)">{{scope.row.chat_no}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="消息状态"
                         align="center">
          <template slot-scope="scope">
            <el-tag size="success"
                    v-if="scope.row.message_status == 1">
              正常
            </el-tag>
            <el-tag size="small"
                    type="info"
                    v-if="scope.row.message_status == 2">
              已隐藏
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发送人"
                         width="280"
                         align="center"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.sender_user_obj.nickname}}/{{
                   scope.row.sender_user_obj.mobile
                }}</span></template>
        </el-table-column>
        <el-table-column label="发送人类型"
                         align="center"
                         width="110">
          <template slot-scope="scope">
            <el-tag size="small"
                    type='warning'
                    v-if="scope.row.sender_user_type == 1">
              学生
            </el-tag>
            <el-tag size="small"
                    v-if="scope.row.sender_user_type == 2">
              学长
            </el-tag>
            <el-tag size="small"
                    type="sucess"
                    v-if="scope.row.sender_user_type == 3">
              管理员
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="200"
                         fixed="right">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handeWihdraw(scope.row)"
                     v-if="scope.row.message_status == 1"><span goDetailclass="cao">隐藏</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="cancleWihdraw(scope.row)"
                     v-if="scope.row.message_status == 2"><span goDetailclass="cao">取消隐藏</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="banned(scope.row,1)"
                     v-if="scope.row.sender_chat_disable_status == 0"><span class="cao">禁言</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="banned(scope.row,2)"
                     v-if="scope.row.sender_chat_disable_status == 1"><span class="cao">取消禁言</span></el-link>

            <el-link type="info"
                     v-if="scope.row.sender_user_type==3||scope.row.sender_user_type==2"
                     :underline="false"
                     @click="disableComment()"><span class="cao">打招呼</span></el-link>
            <el-link type="primary"
                     :underline="false"
                     v-else
                     @click="undercarriage(scope.row,2)"><span class="cao">打招呼</span></el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <communicate :detailRow="detailRow"
                 :visible="detailDialog"
                 :content="detailRow"
                 :title="title"
                 @close="close"
                 @getlist="messageList"></communicate>
    <greeting :visible="greetingDialog"
              :greetingType="type"
              @commcateSubmit="fetchList()"
              @listSubmit="messageList()"
              :content="greetingDetail"
              @close="greetingClose"></greeting>
    <UserDetail :visible="seniorVisible"
                :rowId="rowId"
                @close="seniorClose()"
                :editFlag="editFlag" />
    <!-- 设置新增关键词 -->
    <el-dialog title="设置提醒关键词"
               :close-on-click-modal="false"
               :visible.sync="setdialogVisible"
               @close="sethandleClose"
               width="750px">
      <div class="setContent">
        <div class="top">
          <div style="display:flex; align-items: center;"> <span class="blue"></span><span>关键词列表</span></div>
          <span class="add"
                @click="add()">+新增</span>
        </div>
        <div style="marginTop:10px">
          <el-table :data="keyWordList"
                    border
                    style="width: 100%">
            <el-table-column prop="keyword"
                             width="200"
                             label="关键词"
                             align="center">
            </el-table-column>
            <el-table-column label="提醒人"
                             width="240"
                             align="center"
                             show-overflow-tooltip>

              <template slot-scope="scope">
                <span v-for="(item,index) in  scope.row.notify_admin_obj_list"
                      :key="index"> {{item.nickname}}、</span></template>
            </el-table-column>
            <el-table-column label="操作"
                             align="center"
                             width="200"
                             fixed="right">
              <template slot-scope="scope">
                <el-link type="primary"
                         :underline="false"
                         @click="keywordEdit(scope.row)"><span class="cao"
                        style="marginRight:10px">编辑</span></el-link>
                <el-link type="primary"
                         :underline="false"
                         @click="keyWordDelete(scope.row)"><span class="cao">删除</span></el-link>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer"
             style="marginTop:40px;marginLeft:80px">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(keyQuery.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(keyQuery.pageSize)"
                         :total="Number(keyPageTotal)"
                         @size-change="handlekeySizeChange"
                         @current-change="handlekeyPageChange"></el-pagination>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="sethandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="sethandleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增关键词弹窗 -->
    <el-dialog :title="keyTitle"
               :close-on-click-modal="false"
               :visible.sync="addialogVisible"
               @close="addhandleClose"
               @open="addhandleOpen"
               width="500px">
      <div class="setContent">
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="关键词"
                        prop="name">
            <el-input v-model="keyQuery.keyword"
                      placeholder="请输入关键词"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="提醒人">
            <el-select v-model="keyQuery.notify_admin_ids"
                       clearable
                       multiple
                       placeholder="请选择提醒人"
                       style="width: 100%;">
              <el-option v-for="item in $store.state.adminList"
                         :key="item.id"
                         :label="item.nickname"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <!-- <el-input placeholder="请输入关键词"
                  v-model="key_word"></el-input> -->
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="addhandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="addhandleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 设置敏感词弹窗 -->
    <el-dialog title="设置敏感词"
               :close-on-click-modal="false"
               :visible.sync="setsensitiveVisible"
               @close="setsensitiveClose"
               @open="setsensitiveOpen"
               width="500px">
      <div class="setContent">
        <div class="top">
          <div style="display:flex; align-item:flex-start">
            <span>敏感词：</span>
            <div style="width:350px;">
              <el-tag v-for="tag in filter.tags"
                      :key="tag.id"
                      closable
                      @close="tagClose(tag)"
                      type="success"
                      style="marginRight:8px;marginBottom:8px">
                {{tag.sensitive_word}}
              </el-tag>
            </div>
          </div>
          <span @click="addSensitive()"
                style="color: #409EFF; cursor: pointer; ">+新增</span>
        </div>
        <div style="marginTop:10px">
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="setsensitiveClose">取 消</el-button>
        <el-button type="primary"
                   @click="sesensitiveSubmit">保存</el-button>
      </div>
    </el-dialog>
    <!-- 新增敏感词弹窗 -->
    <el-dialog title="新增敏感词"
               :close-on-click-modal="false"
               :visible.sync="addsensitiveVisible"
               @close="addsensitiveClose"
               @open="addsensitiveOpen"
               width="500px">
      <div class="setSensitive">
        <div style="width:90px">敏感词：</div>
        <el-input v-model="sensitive_word"
                  placeholder="请输入敏感词"
                  clearable></el-input>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="addsensitiveClose">取 消</el-button>
        <el-button type="primary"
                   @click="addsensitiveSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 设置消息自动回复 -->
    <el-dialog title="设置"
               :close-on-click-modal="false"
               :visible.sync="addserviceVisible"
               @close="servicehandleClose"
               @open="servicehandleOpen"
               width="500px">
      <div class="setContent">
        <el-form class="search-wrap"
                 :inline="true"
                 :model="serviceQuery">
          <el-form-item label="客服昵称"
                        prop="name"
                        label-width="100px">
            <el-input v-model="serviceQuery.seniorChatCustomServicerNickname"
                      style="width:260px"
                      placeholder="请输入客服昵称"
                      clearable></el-input>
            <span class="update"
                  @click="nicknamePut(1)">立即更新</span>
          </el-form-item>
          <div></div>
          <el-form-item label="客服头像"
                        prop="seniorChatCustomServicerAvatarUrl"
                        label-width="100px">
            <el-upload class="cover-uploader"
                       :action="imgUploadUrl"
                       :headers="uploadHeaders"
                       :show-file-list="false"
                       :on-success="handleUploadSuccess"
                       :before-upload="handleBeforeUpload">
              <img v-if="serviceQuery.seniorChatCustomServicerAvatarUrl"
                   :src="serviceQuery.seniorChatCustomServicerAvatarUrl"
                   class="cover">
              <i v-else
                 class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <div></div>
          <el-form-item label="自动回复图片"
                        label-width="100px"
                        prop="seniorChatCustomServicerAvatarUrl">
            <el-upload class="cover-uploader"
                       :action="imgUploadUrl"
                       :limit="1"
                       :class="serviceQuery.seniorChatAutoReplyImgUrl ? 'hide_box' : ''"
                       list-type="picture-card"
                       :headers="uploadHeaders"
                       :file-list="imgList"
                       :on-success="handlePictureSuccess"
                       :on-remove="handleRemove"
                       :before-upload="handleBeforePictureUpload">
              <i class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <div></div>
          <el-form-item label="自动回复文字"
                        prop="name"
                        label-width="100px">
            <el-input v-model="serviceQuery.seniorChatAutoReplyText"
                      style="width:260px"
                      autosize
                      type="textarea"
                      placeholder="请输入文字"
                      clearable></el-input>
            <span class="update"
                  @click="nicknamePut(2)">立即更新</span>
          </el-form-item>
          <div></div>
          <el-form-item label="企业微信地址"
                        prop="name"
                        label-width="100px">
            <div> <el-input v-model="serviceQuery.seniorChatAutoReplyEWechatUrl"
                        style="width:260px"
                        placeholder="请输入企业微信地址"
                        clearable></el-input>
              <span class="update"
                    @click="nicknamePut(3)">立即更新</span>
            </div>

          </el-form-item>
        </el-form>
      </div>
      <!-- <div slot="footer"
           class="dialog-footer">
        <el-button @click="addhandleClose">取 消</el-button>
        <el-button type="primary"
                   @click="addhandleSubmit">确 定</el-button>
      </div> -->
    </el-dialog>
    <!-- 设置答疑时间关键词 -->
    <el-dialog title="答疑截止时间"
               :close-on-click-modal="false"
               :visible.sync="answerVisible"
               @close="answerhandleClose"
               @open="answerhandleOpen"
               width="500px">
      <el-form>
        <el-form-item label="答疑截止时间">
          <el-date-picker v-model="answer_unlock_expire_time"
                          @change="handleDateChange"
                          type="datetime"
                          format="yyyy-MM-dd HH:mm"
                          value-format="timestamp"
                          placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>

      </el-form>

      <div class="footer">
        <div class="cancle"
             @click="answerhandleClose()">取消</div>
        <div class="confirm"
             @click="handleTimePut()">确认</div>

      </div>

    </el-dialog>

  </div>
</template>
<script>
import {
  chatList,
  messageList,
  messageHide,
  hideCancel,
  chatCancel,
  chatUserExtend,
  keyworNotifyList,
  addkeyworNotify,
  editkeyworNotify,
  detekeyworNotify,
  SensiitivList,
  addSensiitive,
  deleteSensitive,
  unlockTimeList,
  seniorDetail,
} from '@/api/senior'
import communicate from '@/components/dialog/senior/communicate'
import UserDetail from '@/components/dialog/senior/userDetail'
import greeting from '@/components/dialog/senior/greeting'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import { configureUpdate, configureList } from '@/api/operation'
export default {
  components: { communicate, greeting, UserDetail },
  data() {
    return {
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      type: null,
      keyTitle: '新增关键词',
      seniorVisible: false,
      editFlag: false,
      detailDialog: false,
      greetingDialog: false,
      setdialogVisible: false,
      addialogVisible: false,
      setsensitiveVisible: false,
      addsensitiveVisible: false,
      addserviceVisible: false,
      answerVisible: false,
      sensitive_word: '',
      key_word: '',
      title: '',
      check_statuses: '0',
      query: {
        pageIndex: 1,
        isPaging: 1,
        pageSize: 10,
        min_message_count: '',
        chat_lock_status: '',
      },
      mquery: {
        pageIndex: 1,
        isPaging: 1,
        pageSize: 10,
        chat_lock_status: '',
      },
      keyQuery: {
        pageIndex: 1,
        pageSize: 10,
        notify_admin_ids: [],
      },
      serviceQuery: {
        seniorChatCustomServicerNickname: '',
        seniorChatCustomServicerAvatarUrl: '',
        seniorChatAutoReplyImgUrl: '',
        seniorChatAutoReplyText: '',
        seniorChatAutoReplyEWechatUrl: '',
      },
      filter: {
        status: [
          { label: '正常', value: '1' },
          { label: '撤回', value: '2' },
        ],
        type: [
          { label: '沟通列表(全部)', value: '0' },
          { label: '沟通列表(未读)', value: '2' },
          { label: '消息列表', value: '1' },
        ],
        count: [
          { label: '全部', value: '' },
          { label: '1条', value: '1' },
          { label: '5条', value: '5' },
          { label: '10条', value: '10' },
          { label: '20条', value: '20' },
        ],
        tags: [],
        chat_lock_status: [
          { label: '全部', value: '' },
          { label: '未锁定', value: '0' },
          { label: '已锁定', value: '1' },
        ],
      },
      dataList: [],
      result: [],
      keyWordList: [],
      pageTotal: 10,
      keyPageTotal: 0,
      detailRow: {},
      greetingDetail: {},
      keywordDetail: {},
      configureList: [],
      imgList: [],
      answer_unlock_expire_time: null,
      rowDetail: {},
      rowId: null,
      editFlag: false,
      unRead: 0,
    }
  },
  created() {
    this.$store.dispatch('getAdminList')
    this.fetchList()
    this.fetchConfigureList()
    this.getStatic()
  },
  methods: {
    // 统计沟通记录未读数
    getStatic() {
      chatList({
        ispaging: 0,
        sys_looked_status: 0,
      }).then((res) => {
        this.unRead = res.count
      })
    },
    handleLookUser(id, type) {
      if (type) {
        seniorDetail({ id: id }).then((res) => {
          this.rowId = res.uid
          this.seniorVisible = true
        })
      } else {
        this.rowId = id
        this.seniorVisible = true
      }
    },
    seniorClose() {
      this.seniorVisible = false
    },
    // 配置列表查询
    fetchConfigureList() {
      configureList().then((res) => {
        if (res) {
          this.configureList = res.list
          this.configureList.map((item) => {
            if (item.code == 'seniorChatCustomServicerNickname') {
              this.serviceQuery.seniorChatCustomServicerNickname = item.value
            }
            if (item.code == 'seniorChatAutoReplyText') {
              this.serviceQuery.seniorChatAutoReplyText = item.value
            }
            if (item.code == 'seniorChatAutoReplyEWechatUrl') {
              this.serviceQuery.seniorChatAutoReplyEWechatUrl = item.value
            }
            if (item.code == 'seniorChatCustomServicerAvatarUrl') {
              this.serviceQuery.seniorChatCustomServicerAvatarUrl = item.value
            }
            if (item.code == 'seniorChatAutoReplyImgUrl') {
              this.serviceQuery.seniorChatAutoReplyImgUrl = item.value
              if (item.value == '') {
                this.imgList
              } else {
                this.imgList = [
                  {
                    url: item.value,
                  },
                ]
              }
            }
          })
        }
      })
    },
    nicknamePut(type) {
      let data = {}
      if (type == 1) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatCustomServicerNickname') {
            data = {
              code: 'seniorChatCustomServicerNickname',
              id: item.id,
              name: item.name,
              value: this.serviceQuery.seniorChatCustomServicerNickname,
            }
          }
        })
      } else if (type == 2) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatAutoReplyText') {
            data = {
              code: 'seniorChatAutoReplyText',
              id: item.id,
              name: item.name,
              value: this.serviceQuery.seniorChatAutoReplyText,
            }
          }
        })
      } else if (type == 3) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatAutoReplyEWechatUrl') {
            data = {
              code: 'seniorChatAutoReplyEWechatUrl',
              id: item.id,
              name: item.name,
              value: this.serviceQuery.seniorChatAutoReplyEWechatUrl,
            }
          }
        })
      } else if (type == 4) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatCustomServicerAvatarUrl') {
            data = {
              code: 'seniorChatCustomServicerAvatarUrl',
              id: item.id,
              name: item.name,
              value: this.serviceQuery.seniorChatCustomServicerAvatarUrl,
            }
          }
        })
      } else if (type == 5) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatAutoReplyImgUrl') {
            data = {
              code: 'seniorChatAutoReplyImgUrl',
              id: item.id,
              name: item.name,
              value: this.serviceQuery.seniorChatAutoReplyImgUrl,
            }
          }
        })
      } else if (type == 6) {
        this.configureList.map((item) => {
          if (item.code == 'seniorChatAutoReplyImgUrl') {
            data = {
              code: 'seniorChatAutoReplyImgUrl',
              id: item.id,
              name: item.name,
              value: '',
            }
          }
        })
      }

      configureUpdate(data).then((res) => {
        this.$message.success('操作成功')
        this.fetchConfigureList()
      })
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.serviceQuery.seniorChatCustomServicerAvatarUrl = res.data.url
        this.nicknamePut(4)
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleDateChange() {},
    handlePictureSuccess(res, fileList) {
      this.imgList = fileList
      if (res.code == 0 && res.data) {
        this.serviceQuery.seniorChatAutoReplyImgUrl = res.data.url
        this.nicknamePut(5)
      } else {
        this.$message.error(res.error)
      }
    },
    handleRemove(file, fileList) {
      this.imgList = fileList
      this.nicknamePut(6)
    },
    handleBeforePictureUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    disableComment() {
      this.$message.error(`暂仅支持学生参与的聊天`)
    },
    // 答疑时间弹窗
    answerhandleClose() {
      this.answerVisible = false
    },
    handleTimePut() {
      let data = {
        arr_senior_chat_id: [this.rowDetail.id],
        answer_unlock_expire_time: this.answer_unlock_expire_time,
      }

      unlockTimeList(data).then((res) => {
        this.fetchList()
        this.answerhandleClose()
        this.$message.success('操作成功!')
      })
    },
    answerhandleOpen() {
      this.answerVisible = true
    },
    handleAnswer(row) {
      this.rowDetail = row
      this.answer_unlock_expire_time = row.answer_unlock_expire_time
      this.answerVisible = true
    },
    //查询关键词列表
    keyWord() {
      keyworNotifyList().then((res) => {
        this.keyPageTotal = res.count
        this.keyWordList = res.list
      })
    },
    // 点击关键词新增
    add() {
      this.keyTitle = '新增关键词'
      this.addialogVisible = true
    },
    // 关键词编辑
    keywordEdit(row) {
      this.addialogVisible = true
      this.keyTitle = '修改关键词'
      this.keywordDetail = row
    },
    // 关键词删除
    keyWordDelete(row) {
      let ids = []
      ids.push(row.id)
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
      }).then((res) => {
        detekeyworNotify({ ids: ids }).then((res) => {
          this.keyWord()
          this.$message.success(`删除成功`)
        })
      })
    },
    create() {
      this.setdialogVisible = true
      this.keyWord()
    },
    sethandleClose() {
      this.setdialogVisible = false
    },
    sethandleSubmit() {},
    addhandleClose() {
      this.addialogVisible = false
      this.keyQuery = {
        keyword: '',
        notify_admin_ids: [],
      }
      this.keywordDetail = {}
    },
    addhandleOpen() {
      this.keyQuery = { ...this.keywordDetail }
      this.keyQuery.notify_admin_ids = this.keywordDetail.notify_admin_ids
        .split(',')
        .map((item) => {
          return item * 1
        })
    },
    addhandleSubmit() {
      if (this.keyTitle == '新增关键词') {
        let data = {
          keyword: this.keyQuery.keyword,
          notify_admin_ids: this.keyQuery.notify_admin_ids.join(','),
        }
        addkeyworNotify(data).then((res) => {
          this.addialogVisible = false
          this.$message.success(`添加成功`)
          this.keyWord()
          this.keyQuery = {
            keyword: '',
            notify_admin_ids: [],
          }
          this.keywordDetail = {}
        })
      } else {
        let data = {
          id: this.keywordDetail.id,
          keyword: this.keyQuery.keyword,
          notify_admin_ids: this.keyQuery.notify_admin_ids.join(','),
        }
        editkeyworNotify(data).then((res) => {
          this.addialogVisible = false
          this.$message.success(`编辑成功`)
          this.keyWord()
          this.keyQuery = {
            keyword: '',
            notify_admin_ids: [],
          }
          this.keywordDetail = {}
        })
      }
    },
    //敏感词词设置
    sensitive() {
      this.setsensitiveVisible = true
    },
    service() {
      this.addserviceVisible = true
    },
    servicehandleOpen() {
      this.addserviceVisible = true
    },
    servicehandleClose() {
      this.addserviceVisible = false
    },
    addSensitive() {
      this.addsensitiveVisible = true
    },
    setsensitiveClose() {
      this.setsensitiveVisible = false
    },
    tagClose(val) {
      let ids = []
      ids.push(val.id)
      deleteSensitive({
        ids: ids,
      }).then((res) => {
        this.$message.success(`删除成功`)
        this.Sensitivlist()
      })
    },
    addsensitiveClose() {},
    addsensitiveOpen() {},
    setsensitiveOpen() {
      this.Sensitivlist()
    },
    //查询敏感词列表
    Sensitivlist() {
      SensiitivList().then((res) => {
        this.filter.tags = res.list
      })
    },
    sesensitiveSubmit() {
      this.setsensitiveVisible = false
    },
    addsensitiveSubmit() {
      addSensiitive({ sensitive_word: this.sensitive_word }).then((res) => {
        this.$message.success(`操作成功`)
        this.sensitive_word = ''
        this.addsensitiveVisible = false
        this.Sensitivlist()
      })
    },
    handlekeySizeChange(val) {
      this.$set(this.keyQuery, 'pageSize', val)
      this.keyWord()
    },
    handlekeyPageChange(val) {
      this.$set(this.keyQuery, 'pageIndex', val)
      this.keyWord()
    },
    dialogDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定删除',
        type: 'warning',
      }).then((res) => {
        chatCancel({ id: row.id }).then((res) => {
          this.fetchList()
          this.$message.success(`删除成功`)
        })
      })
    },
    //隐藏
    handeWihdraw(row) {
      this.$confirm('确定要隐藏吗？', '提示', {
        confirmButtonText: '确定隐藏',
        type: 'warning',
      }).then((res) => {
        messageHide({ senior_chat_message_id: row.id }).then((res) => {
          this.messageList()
          this.$message.success(`操作成功`)
        })
      })
    },
    cancleWihdraw(row) {
      this.$confirm('确定要取消吗？', '提示', {
        confirmButtonText: '确定取消隐藏',
        type: 'warning',
      }).then((res) => {
        hideCancel({ senior_chat_message_id: row.id }).then((res) => {
          this.messageList()
          this.$message.success(`操作成功`)
        })
      })
    },
    //禁言
    banned(row, type) {
      let data = {}
      if (type == 1) {
        data = {
          uid: row.sender_chat_user_uid,
          chat_disable_status: 1,
        }
        this.$confirm('确定要禁言吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then((res) => {
          chatUserExtend(data).then((res) => {
            this.$message.success(`操作成功`)
            this.messageList()
          })
        })
      } else {
        data = {
          uid: row.sender_user_obj.id,
          chat_disable_status: 0,
        }
        this.$confirm('确定要取消禁言吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then((res) => {
          chatUserExtend(data).then((res) => {
            this.$message.success(`操作成功`)
            this.messageList()
          })
        })
      }
    },
    // 沟通列表
    fetchList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      let parmas = Object.assign({}, this.query)
      if (this.check_statuses == '2') {
        parmas.sys_looked_status = 0
      }
      chatList(parmas).then((res) => {
        this.dataList = res.list
        this.pageTotal = res.count
      })
    },
    //消息列表
    messageList() {
      let parmas = Object.assign({}, this.mquery)
      messageList(parmas).then((res) => {
        this.result = res.list
        this.pageTotal = res.count
      })
    },
    checkStatus() {
      this.query.pageIndex = 1
      this.mquery.pageIndex = 1
      this.result = []
      this.dataList = []

      if (this.check_statuses == '1') {
        this.messageList()
      } else {
        this.fetchList()
      }
    },
    handelDetail(row, type) {
      this.detailRow = row

      if (type == 1) {
        this.title = '聊天详情'
      } else {
        this.title = '沟通记录'
      }
      this.detailDialog = true
    },
    close() {
      this.detailDialog = false
    },
    greetingClose() {
      this.greetingDialog = false
    },
    undercarriage(row, type) {
      this.greetingDetail = row
      this.greetingDialog = true
      this.type = type
    },
    handleSizeChange(val) {
      if (this.check_statuses == '0' || this.check_statuses == '2') {
        this.$set(this.query, 'pageSize', val)
        this.fetchList()
      } else {
        this.$set(this.mquery, 'pageSize', val)
        this.messageList()
      }
    },
    handlePageChange(val) {
      if (this.check_statuses == '0' || this.check_statuses == '2') {
        this.$set(this.query, 'pageIndex', val)
        this.fetchList()
      } else {
        this.$set(this.mquery, 'pageIndex', val)
        this.messageList()
      }
    },
  },
}
</script>
<style scoped lang="less">
::v-deep .el-badge__content.is-fixed {
  top: -8px;
}
::v-deep .el-table__fixed-right {
  background: #fff;
  z-index: 99 !important; /* 数值需高于滚动内容的z-index */
}
.unread {
  margin-top: 15px;
  display: inline-block;
  text-align: center;
  width: 25px;
  font-size: 8px;
  height: 15px;
  color: #fff;
  line-height: 15px;
  background: #f56c6c;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #f56c6c;
}
.thumbnail {
  width: 38px;
  height: 38px;
}
.hide_box {
  ::v-deep.el-upload--picture-card {
    display: none;
  }
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 148px;
  height: 148px;
}
.update {
  margin-left: 10px;
  border-radius: 8px;
  display: inline-block;

  width: 80px;
  line-height: 30px;
  text-align: center;
  height: 30px;
  color: #fff;
  background: #409eff;
}
.cover-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  width: 148px;
  height: 148px;
  object-fit: cover;
}
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
.article {
  .contentTop {
    display: flex;
    justify-content: space-between;
    .breadcrumb {
      margin-bottom: 30px;
    }
    .create {
      cursor: pointer;
      font-size: 14px;
      color: #ffff;
      width: 100px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
    .service {
      cursor: pointer;
      font-size: 14px;
      color: #ffff;
      width: 80px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      background: #409eff;
      border-radius: 4px 4px 4px 4px;
    }
  }
  .card {
    margin-top: 5px;
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .values {
      display: flex;
      flex-wrap: wrap;
      flex: 1;
      .table-header {
        display: flex;
        justify-content: space-between;
        width: 101%;
        height: 40px;

        .title {
          font-size: 20px;
        }
        .blue {
          margin-right: 30px;
          width: 4px;
          height: 20px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
      }
    }
    .value-item {
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      padding: 0 10px;
      margin-right: 5px;
      cursor: pointer;

      &.active {
        color: #fff;
        background: #409eff;
      }
    }
  }
  .results {
    margin-top: 20px;
    padding-right: 32px;
    .table-header {
      display: flex;
      justify-content: space-between;
      .tableleft {
        display: flex;
        .blue {
          width: 4px;
          height: 20px;
          background: #409eff;
          border-radius: 4px 4px 4px 4px;
        }
        .title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 20px;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }

    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .setContent {
    .top {
      display: flex;
      justify-content: space-between;

      .blue {
        margin-right: 5px;
        display: inline-block;
        width: 4px;
        height: 16px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }

      .add {
        line-height: 28px;
        text-align: center;
        width: 56px;
        height: 28px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #409eff;
        cursor: pointer;
        font-size: 14px;
        color: #409eff;
      }
    }
    // .display:flex;align-content: center;

    .tagBox {
      max-width: 350px;
    }
  }
  .setSensitive {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 350px;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    .cancle {
      text-align: center;
      font-size: 14px;
      width: 56px;
      height: 36px;
      line-height: 36px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #dcdfe6;
      margin-right: 10px;
    }
    .confirm {
      text-align: center;
      width: 56px;
      height: 36px;
      font-size: 14px;
      line-height: 36px;
      color: #fff;
      background: #1f86fe;
      border-radius: 4px 4px 4px 4px;
    }
  }
}
</style>